/**
 * 基础的地图组件，初始化地图，但不做任何具体业务，由AppMap.vue组件调用一次
 */
import * as mapvgl from 'mapvgl'
import yanmouStyle from '@/common/map.style.yanmou.js'
import loadBMapGL from '@/common/BMapGL.js'

function AppMap() {
  this.map = undefined
  this.view = undefined
  this.BMapGL = undefined
  this.defaultZoom = 12.8
  var convertor
  this.init = (container, loaded) => {
    loadBMapGL().then((BMapGL) => {
      this.BMapGL = BMapGL
      convertor = new this.BMapGL.Convertor()
      this.map = new BMapGL.Map(container, {
        minZoom: 10.8,
        maxZoom: 18.8,
        style: {
          styleJson: yanmouStyle
        }
      })
      const {
        map
      } = this
      map.enableScrollWheelZoom()
      map.centerAndZoom(new BMapGL.Point(117.18, 32.12), this.defaultZoom)

      this.view = new mapvgl.View({
        map: map,
      })
      loaded()
    })
  }

  this.fly2 = function (lng, lat, zoom, options) {
    return new Promise(resolve => {
      this.convert(lng, lat).then(p => {
        let opt = Object.assign({
          tilt: 60,
          heading: 0,
          callback: () => {
            resolve()
          }
        }, options ? options : {})
        this.map.flyTo(p, zoom, opt)
      })
    })
  }

  this.convert = function (m, n) {
    if ((typeof m) === 'number' && (typeof n) === 'number') {
      // 输入是2个数字
      return new Promise(resolve => {
        convertor.translate([new BMapGL.Point(m, n)], COORDINATES_WGS84, COORDINATES_BD09, (data) => {
          resolve(data.points[0])
        })
      })
    }
  }

}
export default new AppMap()



// WEBPACK FOOTER //
// ./src/components/screen28896/map-zone/AppMap.js